import {app} from './app'
import {Harvest} from './pages/harvest'
import {Decoder} from './pages/decoder.imba'
import {Level} from './pages/level.imba'
import './fonts.css'

global css html
	ff: 'Montserrat'
	# tt: uppercase
	c: white
	body
		m: 0
		# pb: 100px
		bg: #04242A
		bgi: url('./images/noise.png')
		bgr: repeat
	h1
		ff: 'Attentica'
		fw: 100
		fs: 56px
		lh: 60px
		h: 48px
		ws: nowrap
		m: 0
		c: rgb(255, 192, 0)
		ts: 0 3px 8px rgb(4, 36, 42), 0 12px 32px rgba(255, 192, 0, 0.5)
		span
			va: super
			fs: 0.53em
			lh: 24px
			# d: inline-block
			# w: 60px
			# ff: 'Montserrat'
			# tt: uppercase
			# fs: 11px
			# lh: 15px
			# ls: 0.5
			# fw: 600
			# ml: 12px
			# c: rgb(255, 236, 179)
			# ts: none
			# va: 14px
		&.none
			ff: 'Montserrat'
			fw: 200
			fs: 80px
			lh: 44px
			# mt: -7px
			# mb: 7px
	h2
		cursor: pointer
		pos: relative
		tt: uppercase
		fs: 14px
		lh: 20px
		fw: 600
		c: rgb(255, 236, 179)
		m: 0
		&.dark
			cursor: default
			o: 0.5
			c: #000
			fw: 700
			ta: center
		&.active
			cursor: default
			c: rgb(255, 192, 0)
		&.disable
			cursor: default
			c: rgba(255, 236, 179, 0.25)
			&:after
				o: 0
				content: ''
				pos: absolute
				l: 0
				b: 100%
				size: 0px
				mb: 4px
				bd: solid 4px rgba(255, 192, 0, 0.3)
				bdr: solid 4px transparent bdb: solid 4px transparent
				transform: translateY(12px)
				tween: 0.2s ease
			&:before
				o: 0
				zi: 100
				content: 'omcginnsoo'
				pos: absolute
				fs: 10px
				lh: 12px
				ws: nowrap
				c: rgb(255, 236, 179)
				bg: rgba(255, 192, 0, 0.05)
				bd: 1px solid rgba(255, 192, 0, 0.25)
				b: 100%
				mb: 12px
				p: 8px 12px
				transform: translateY(12px)
				backdrop-filter: blur(2px)
				tween: 0.2s ease
			&:hover
				&:after, &:before
					o: 1
					transform: translateY(0px)
	h3
		fs: 20px
		lh: 20px
		fw: 600
		tt: uppercase
		c: rgb(255, 192, 0)
		m: 0px
	h4
		fs: 14px
		lh: 20px
		fw: 500
		c: rgb(255, 236, 179)
		m: 0
	h5
		ff: 'Attentica 4F'
		fw: 100
		fs: 40px
		m: 0
		c: rgb(255, 192, 0)
	# h6
	p, a
		fs: 11px
		lh: 16px
		tt: uppercase
		fw: 600
		c: rgb(255, 236, 179)
		m: 0px
		td: none
	a cursor: pointer
	label
		ff: 'Montserrat'
		fs: 12px
		fw: 500
		lh: 32px
		c: rgb(255, 236, 179)
		fl: 1 0 240px
		mt: 32px
		&.sw
			fl: 1 0 auto
			lh: 16px
			cursor: pointer
			d: flex
			fld: row-reverse
			jc: start
			ai: center
			g: 12px
	label@!450
		mt: 16px
		&.sw
			mt: 24px
	form
		d: flex
		flw: wrap
		gcg: 40px
		m: 0

css app-tag
	d: flex
	fld: column
	m: auto
	g: 20px
	max-width: 1000px
	p: 24px
	pt: 16px
	bgs: 100%

css app-tag @!600
	p: 16px

global css .block
	d: flex
	fld: column
	of: hidden
	g: 24px
	p: 40px
	bg: linear-gradient(to left top, rgba(255, 192, 0, .1), rgba(255, 192, 0, 0.025))
	bd: 1px solid rgba(255, 192, 0, 0.25)
	of: hidden
	&:first-child
		rdtl: 20px
	&:last-child
		rdbr: 20px
	&.results
		bg: rgba(255, 192, 0, 0.15)
		# pb: 28px
		bdt: none
		.results-data
			d: flex
			flw: wrap
			cg: 40px
			rg: 32px
			.cap
				fl: 1
				flg: 1
				d: flex
				g: 8px
				ai: start
				p
					w: min-content
					ws: pre-wrap

global css .block@!600
	p: 24px

global css input
	ff: 'Montserrat'
	fs: 16px
	fw: 600
	c: rgb(255, 236, 179)
	h: 56px
	w: 100%
	p: 0 16px 0 16px
	bd: 1px solid rgba(255, 192, 0, 0.25)
	bg: transparent
	rd: 0
	outline: none
	tween: 0.25s ease
	-moz-appearance: textfield
	-webkit-appearance: textfield
	appearance: textfield
	&::-webkit-outer-spin-button, &::-webkit-inner-spin-button
		display: none
	&:hover, &:focus
		bd: 1px solid rgba(255, 192, 0, 1)
	&::placeholder
		ff: 'Montserrat'
		fs: 16px
		fw: 500
		c: rgba(255, 236, 179, 0.25)

global css .switch
	cursor: pointer
	pos: relative
	# d: block
	w: 36px
	h: 20px
	rd: 100px
	box-sizing: border-box
	bd: 1px solid rgba(255, 192, 0, 0.25)
	tween: 0.25s ease
	&::before
		content: ''
		pos: absolute
		h: 14px w: 14px
		t:0 b:0 l:0
		m: auto
		ml: 2px
		rd: 50%
		bg: rgba(255, 192, 0, 0.25)
		tween: margin-left 0.25s ease
	&.active
		bc: rgba(255, 192, 0, 1)
		&::before
			ml: 50%
			t: 0 b: 0 l:0
			bg: rgba(255, 192, 0, 1)
	p
		d: flex
		fld: row-reverse
		jc: start
		ai: center
		g: 12px
		tt: none fw: 500

global css .plus-minus
	display: grid
	gtc: 56px 1fr 56px
	.pls-btn
		cursor: pointer
		pos: relative
		width: auto
		height: auto
		bd: 1px solid rgba(255, 192, 0, 0.25)
		bdl: 1px solid rgba(255, 192, 0, 0)
		ml: -1px
		tween: 0.25s ease
		&::before
			content: ''
			position: absolute
			l: 0
			r: 0
			t: 0
			b: 0
			m: auto
			width: 15px
			height: 1px
			bg: rgba(255, 192, 0, 1)
		&::after
			content: ''
			position: absolute
			l: 0
			r: 0
			t: 0
			b: 0
			m: auto
			width: 1px
			height: 15px
			bg: rgba(255, 192, 0, 1)
		&:hover
			bd: 1px solid rgba(255, 192, 0, 1)
	.mns-btn
		cursor: pointer
		pos: relative
		width: auto
		height: auto
		bd: 1px solid rgba(255, 192, 0, 0.25)
		bdr: 1px solid rgba(255, 192, 0, 0)
		mr: -1px
		tween: 0.25s ease
		&::before
			content: ''
			position: absolute
			l: 0
			r: 0
			t: 0
			b: 0
			m: auto
			width: 15px
			height: 1px
			bg: rgba(255, 192, 0, 1)
		&:hover
			bd: 1px solid rgba(255, 192, 0, 1)

global css .hab-list
	d: flex
	fld: row-reverse
	flw: wrap-reverse
	ai: start
	cg: 40px
	rg: 24px
	mt: 32px
global css .hab-list@!600
	mt: 24px

css .pages
	zi: 3
	w: 100%
	# max-width: 800px
	d: block
	pos: relative
	d: grid
	gaf: row
	m: auto
	# grid-gap: 32px

css .nav-tabs
	d: flex
	ws: nowrap
	jc: start
	gap: 40px
	ofy: hidden
	p: 8px 40px
	&::-webkit-scrollbar
		# visibility: hidden
		h: 0
css .nav-tabs@!600
	p: 0px 24px
	g: 24px

css header
	pos: relative
	m: auto
	l: 0
	r: 0
	.headline
		d: flex
		jc: space-between
		ai: center
		cg: 12px
		rg: 0px
		p: 0 40px
		mb: 16px
		tt: uppercase
		fw: 600
		p
			lh: 20px
			.icon
				w: 14px
				h: 14px
				svg
					fill: rgba(255, 192, 0, 0.25)
					stroke: rgb(255, 192, 0)
					h: 18px
					w: 18px
					mt: -2px
			svg@!600
				h: 14px
				w: 14px
			span
				&:first-child
					mr: 10px
				&:last-child
					mb: 2px
					d: inline-flex
					ai: center
					g: 12px
					flw: nowrap
					va: middle
			a
				c: rgb(255, 192, 0)
				ts: 0 2px 2px rgb(4, 36, 42), 0 4px 16px rgba(255, 192, 0, 0.5)
		.language
			pos: relative
			d: flex
			ai: center
			g: 20px
			&::before
				content: ''
				pos: absolute
				l:0 r:0 t:0 b:0
				w:1px h:50%
				bg: rgb(255, 236, 179)
				m: auto
			p cursor: pointer p: 8px
			.active
				c: rgb(255, 192, 0)
	.headline@!600
		p: 0 24px
		mb: 16px
	.donate
		d: flex
		jc: space-between
		ai: center
		bg: rgba(255, 192, 0, 0.25)
		bd: 1px solid rgb(255, 192, 0)
		bdt: none
		rd: 0 0 32px 0
		p: 24px 40px
		mt: -1px
		.wallet
			cursor: pointer
			d: flex
			ai: center
			gap: 8px
			p: 16px 24px
			bg: rgba(255, 192, 0)
			p
				tt: uppercase
				fw: 800
				c: rgb(4, 36, 42, 0.9)
			svg
				fill: rgb(4, 36, 42, 0.9)
				w: 18px
				h: 18px
				d: block
				line-height: 1em
				fill-rule: evenodd
				clip-rule: evenodd
	img
		w: 100%
		box-sizing: border-box
		bd: 1px solid rgba(255, 192, 0, 0.25)
		rd: 0 0 20px 0
		mt: -1px

css .ratetokens
	d: flex
	flw: wrap
	ai: center
	g: 40px
	p: 20px 40px
	bg: red4
	bg: rgba(255, 192, 0, 0.05)
	bd: 1px solid rgba(255, 192, 0, 0.25)
	rd: 20px 0 0 0
	.token
		d: flex
		ai: center
		g: 8px
		p
			fs: 16px
			fw: 600
			c: rgb(255, 236, 179)
		.token-icon
			d: flex
			ai: center
			w: 18px
			h: 18px
			svg
				fill: rgb(255, 192, 0)
				w: 18px
				h: 18px
				d: block
				line-height: 1em
				fill-rule: evenodd
				clip-rule: evenodd
css .ratetokens@!600
	cg: 20px
	rg: 8px
	p: 12px 24px
	.token
		p
			fs: 11px
		.token-icon
			w: 14px h: 14px

global css .harvest-tabs
	d: flex
	jc: start
	g: 40px
	bdb: 1px solid rgba(255, 192, 0, 0.25)
	mb: -4px
	h2
		fl: auto
		flg: 0
		cursor: pointer
		# min-width: min-content
		pb: 24px
		&.active
			cursor: default
			c: rgba(255, 192, 0, 1)
			bdb: 2px solid rgba(255, 192, 0, 1)
global css .harvest-tabs@!600
	h2
		fl: 1
		flg: 0

tag app
	def render
		if router.path == "/" then router.go '/harvest'
		<self>
			<header>
				<.headline>
					<p>
						<span> app.trans.devs[app.lg]
						<span @click=(do window.open('https://t.me/genopets_ru'))>
							<.icon>
								<svg viewBox="0 0 24 24">
									<path d="M11.1788 12.7488L14.3378 22.2929C14.6495 23.2347 15.9892 23.236 16.3028 22.2948L22.9458 2.35375C23.2135 1.54998 22.4444 0.786807 21.6364 1.05456L1.70748 7.65857C0.764174 7.97116 0.764175 9.29761 1.70748 9.6102L11.1788 12.7488ZM11.1788 12.7488L15.3174 8.63438">
							<a> app.trans.join[app.lg]
					<.language>
						<p .active=(app.lg == 1) @click=(do app.lg = 1)> 'RU'
						<p .active=(app.lg == 0) @click=(do app.lg = 0)> 'EN'
				<.ratetokens>
					<.token>
						<.token-icon>
							<svg viewBox="0 0 18 18">
								<path d="M3.54265 12.6134C3.64279 12.5132 3.74292 12.4131 3.94319 12.4131H16.7604C16.9607 12.4131 17.0609 12.7135 16.9607 12.8136L14.4573 15.317C14.3572 15.4171 14.2571 15.5173 14.0568 15.5173H1.23955C1.03928 15.5173 0.939149 15.2169 1.03928 15.1167L3.54265 12.6134Z">
								<path d="M3.54265 3.20027C3.64279 3.10013 3.74292 3 3.94319 3H16.7604C16.9607 3 17.0609 3.3004 16.9607 3.40054L14.4573 5.90391C14.3572 6.00404 14.2571 6.10418 14.0568 6.10418H1.23955C1.03928 6.10418 0.939149 5.80377 1.03928 5.70364L3.54265 3.20027Z">
								<path d="M14.3572 7.90584C14.2571 7.8057 14.1569 7.70557 13.9567 7.70557H1.23955C1.03928 7.70557 0.939149 8.00597 1.03928 8.10611L3.54265 10.6095C3.64279 10.7096 3.74292 10.8097 3.94319 10.8097H16.7604C16.9607 10.8097 17.0609 10.5093 16.9607 10.4092L14.3572 7.90584Z">
						<p> app.rates.sol.toFixed(4)
					<.token>
						<.token-icon>
							<svg viewBox="0 0 24 24">
								<path d="M10,0L0,6L0,18L10,24L20,18L20,11.503L14.781,11.503L14.781,12.497L19.044,12.497L19.044,17.426L13.347,20.845L13.347,17.357L7.61,13.709L7.61,12.497L12.39,12.497L12.39,13.709L10.458,14.938L11.374,15.52L13.347,14.266L13.347,9.727L7.61,6.25L7.61,2.581L10,1.147L12.39,2.582L12.39,6.25L10.475,7.411L11.423,7.986L13.347,6.821L13.347,3.155L19.044,6.574L19.044,8.522L20,8.522L20,6L10,0ZM7.61,11.503L12.39,11.503L12.39,10.298L6.654,6.821L6.654,3.155L0.956,6.574L0.956,17.426L6.654,20.845L6.654,17.357L8.626,16.103L9.542,16.685L7.61,17.914L7.61,21.419L10,22.853L12.39,21.419L12.39,17.914L6.654,14.266L6.654,9.727L8.577,8.562L9.526,9.137L7.61,10.298L7.61,11.503Z">
						<p> app.rates.gene.toFixed(4)
					<.token>
						<.token-icon>
							<svg viewBox="0 0 32 32">
								<path d="M2.66675 23.7701V8.36803L9.30819 4.54508V19.745L23.0956 10.2336L24.8018 11.2904L15.3992 17.7876L25.2513 24.2296L27.6731 22.8695V9.32377L15.9955 2.57847L11.0144 5.50082L11.0695 3.5342L15.9955 0.666992L29.3334 8.36803V23.7701L25.0495 26.187L13.7297 18.9455L9.25315 21.9138L7.64783 21.1051L7.54692 7.41229L4.27207 9.27782V22.7684L15.9955 29.5689L21.3343 26.4903L22.9397 27.5012L15.9955 31.4803L2.66675 23.7701Z">
						<p> app.rates.ki.toFixed(4)
				<img src='./images/Banner.jpeg'>
				# <.donate>
				# 	<.text>
				# 		<h2> 'Donate dev'
				# 		<p> 'Help the developer to develop new features!'
				# 	<.wallet @click=CopyWallet>
				# 		<svg viewBox="0 0 18 18">
				# 			<path d="M3.54265 12.6134C3.64279 12.5132 3.74292 12.4131 3.94319 12.4131H16.7604C16.9607 12.4131 17.0609 12.7135 16.9607 12.8136L14.4573 15.317C14.3572 15.4171 14.2571 15.5173 14.0568 15.5173H1.23955C1.03928 15.5173 0.939149 15.2169 1.03928 15.1167L3.54265 12.6134Z">
				# 			<path d="M3.54265 3.20027C3.64279 3.10013 3.74292 3 3.94319 3H16.7604C16.9607 3 17.0609 3.3004 16.9607 3.40054L14.4573 5.90391C14.3572 6.00404 14.2571 6.10418 14.0568 6.10418H1.23955C1.03928 6.10418 0.939149 5.80377 1.03928 5.70364L3.54265 3.20027Z">
				# 			<path d="M14.3572 7.90584C14.2571 7.8057 14.1569 7.70557 13.9567 7.70557H1.23955C1.03928 7.70557 0.939149 8.00597 1.03928 8.10611L3.54265 10.6095C3.64279 10.7096 3.74292 10.8097 3.94319 10.8097H16.7604C16.9607 10.8097 17.0609 10.5093 16.9607 10.4092L14.3572 7.90584Z">
				# 		<p> 'Copy wallet address'
			<.nav-tabs>
				<h2 .active=(router.path == '/harvest') @click=(do route-to='/harvest')> app.trans.tab1[app.lg]
				<h2 .active=(router.path == '/levelup') @click=(do route-to='/levelup')> app.trans.tab2[app.lg]
				<h2 .active=(router.path == '/decoder') @click=(do route-to='/decoder')> app.trans.tab3[app.lg]
			<.pages>
				<Harvest route='/harvest'>
				<Level route='/levelup'>
				<Decoder route='/decoder'>
			<h2.dark> app.trans.slogan[app.lg]


imba.mount <app>